import { StyleSheet } from "@react-pdf/renderer";
import theme from "../../../../../css/WhiteLabelledDocuments/theme";
import { Font } from "@react-pdf/renderer";
import OpenSansBold from "../../../../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansRegular from "../../../../../assets/fonts/Open_Sans/OpenSans-Regular.ttf";

Font.register({
  family: "Open Sans",
  fonts: [
    { src: OpenSansBold, fontWeight: "bold" },
    { src: OpenSansRegular, fontWeight: "normal" },
  ],
});

//  Helper to convert hex to RGB
const hexToRgb = (hex) => {
  //   const cleanHex = hex.replace("#", "");
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

// Helper to calculate brightness
const getTextColor = (hex) => {
  const { r, g, b } = hexToRgb(hex);
  // relative luminance formula
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 186 ? "#000000" : "#ffffff"; // threshold
};

const blendWithWhite10 = (hex, opacity = 0.1) => {
  const { r, g, b } = hexToRgb(hex);
  const blended = {
    r: Math.round((1 - opacity) * 255 + opacity * r),
    g: Math.round((1 - opacity) * 255 + opacity * g),
    b: Math.round((1 - opacity) * 255 + opacity * b),
  };
  return `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
};

const blendWithWhite = (hex, opacity = 0.1) => {
  const { r, g, b } = hexToRgb(hex);
  const blended = {
    r: Math.round((1 - opacity) * 255 + opacity * r),
    g: Math.round((1 - opacity) * 255 + opacity * g),
    b: Math.round((1 - opacity) * 255 + opacity * b),
  };
  return `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
};

const AnnualGuideStyles = (primaryColor) =>
  // const textColor = getTextColor(primaryColor);
  // const highlightBg = blendWithWhite(primaryColor, 0.1);
  // const headerfooterBg = blendWithWhite10(primaryColor, 0.3);

  StyleSheet.create({
    page: {
      padding: 30,
      fontSize: 11,
      gap: 10,
      marginTop: 10,
      marginBottom: 10,
    },
    graphicWrapper: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
    graphicBox: {
      position: "absolute",
      top: "-102%",
      left: "-60%",
      width: "110%",
      height: "250%",
      transform: "rotate(45deg)",
      backgroundColor: `#${primaryColor}`,
    },
    graphicBox1: {
      backgroundColor: blendWithWhite(primaryColor, 0.8),
      position: "absolute",
      bottom: "40%",
      right: "-130%",
      width: "190%",
      height: "250%",
      transform: "rotate(35deg)",
    },
    graphicBox2: {
      backgroundColor: blendWithWhite10(primaryColor, 0.6),
      position: "absolute",
      bottom: "73%",
      right: "-20%",
      width: "200%",
      height: "2%",
      transform: "rotate(35deg)",
    },
    graphicBox3: {
      backgroundColor: blendWithWhite10(primaryColor, 0.1),
      position: "absolute",
      bottom: "75.3%",
      right: "-20%",
      width: "200%",
      height: "2%",
      transform: "rotate(35deg)",
    },
    graphicBox14: {
      position: "absolute",
      top: "-102%",
      left: "-60%",
      width: "110%",
      height: "250%",
      transform: "rotate(45deg)",
      backgroundColor: blendWithWhite10(primaryColor, 0.4),
    },
    graphicBox15: {
      backgroundColor: `#${primaryColor}`,
      position: "absolute",
      bottom: "40%",
      right: "-130%",
      width: "190%",
      height: "250%",
      transform: "rotate(35deg)",
    },
    graphicBox16: {
      backgroundColor: blendWithWhite(primaryColor, 0.8),
      position: "absolute",
      bottom: "73%",
      right: "-20%",
      width: "200%",
      height: "2%",
      transform: "rotate(35deg)",
    },
    graphicBox17: {
      backgroundColor: blendWithWhite10(primaryColor, 0.3),
      position: "absolute",
      bottom: "75.3%",
      right: "-20%",
      width: "200%",
      height: "2%",
      transform: "rotate(35deg)",
    },
    graphicBox4: {
      position: "absolute",
      bottom: "-3%",
      right: "23%",
      width: 50,
      height: 50,
      transform: "rotate(45deg)",
      backgroundColor: `#${primaryColor}`,
    },
    graphicBox5: {
      backgroundColor: blendWithWhite(primaryColor, 0.5),
      position: "absolute",
      bottom: "-2%",
      right: "20%",
      width: 35,
      height: 35,
      transform: "rotate(45deg)",
    },
    graphicBox6: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.3),
      position: "absolute",
      bottom: "0%",
      right: "35%",
      width: 40,
      height: 40,
      border: `2px solid ${blendWithWhite(primaryColor, 0.8)}`,
      transform: "rotate(45deg)",
    },
    graphicBox7: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.4),
      border: `3px solid ${blendWithWhite(primaryColor, 0.6)}`,
      position: "absolute",
      bottom: "-5%",
      right: "3%",
      width: 70,
      height: 70,
      transform: "rotate(45deg)",
    },
    graphicBox8: {
      backgroundColor: blendWithWhite(primaryColor, 0.5),
      position: "absolute",
      bottom: "-3%",
      right: "45%",
      width: 30,
      height: 30,
      transform: "rotate(45deg)",
    },
    graphicBox9: {
      position: "absolute",
      bottom: "-3%",
      right: "23%",
      width: 50,
      height: 50,
      transform: "rotate(45deg)",
      backgroundColor: `#${primaryColor}`,
    },
    graphicBox10: {
      backgroundColor: blendWithWhite(primaryColor, 0.6),
      position: "absolute",
      bottom: "-2%",
      right: "20%",
      width: 35,
      height: 35,
      transform: "rotate(45deg)",
    },
    graphicBox11: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.3),
      position: "absolute",
      bottom: "0%",
      right: "35%",
      width: 40,
      height: 40,
      border: `2px solid ${blendWithWhite(primaryColor, 0.4)}`,
      transform: "rotate(45deg)",
    },
    graphicBox12: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.4),
      border: `3px solid ${blendWithWhite(primaryColor, 0.2)}`,
      position: "absolute",
      bottom: "-5%",
      right: "3%",
      width: 70,
      height: 70,
      transform: "rotate(45deg)",
    },
    graphicBox13: {
      backgroundColor: blendWithWhite(primaryColor, 0.5),
      position: "absolute",
      bottom: "-3%",
      right: "45%",
      width: 30,
      height: 30,
      transform: "rotate(45deg)",
    },
    header: {
      fontFamily: "Open Sans",
      fontSize: 18,
      textAlign: "center",
      fontWeight: "bold",
      letterSpacing: 1,
      color: `#${primaryColor}`,
      alignItems: "center",
      // flexGrow: 1,
    },
    pageHeader: {
      position: "absolute",
      top: 20,
      left: 30,
      right: 30,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      // backgroundColor: `#${primaryColor}`,
    },
    pageWithChrome: {
      paddingLeft: 30,
      paddingRight: 30,
      paddingTop: 40,
      paddingBottom: 50,
    },
    pageHeaderText: {
      fontSize: 8,
      color: blendWithWhite(primaryColor, 0.6),
    },
    pageFooterText: {
      fontSize: 6,
      textAlign: "center",
      color: blendWithWhite(primaryColor, 0.6),
    },
    footer: {
      position: "absolute",
      bottom: 20,
      left: 30,
      right: 30,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      fontSize: 10,
    },
    footerText: {
      fontSize: 10,
      color: blendWithWhite(primaryColor, 0.6),
    },
    pageNumber: {
      fontSize: 10,
      color: blendWithWhite(primaryColor, 0.6),
      textAlign: "right",
    },
    row: {
      flexDirection: "row", // Align items horizontally
      justifyContent: "space-between", // Push content to edges
      alignItems: "center", // Align items vertically in the center
      alignContent: "center",
    },
    column: {
      flexDirection: "column", // Align items horizontally
      justifyContent: "center", // Push content to edges
      alignItems: "center", // Align items vertically in the center
      alignContent: "center",
      marginBottom: 10,
    },

    iconImages: {
      display: "flex",
      flex: 1,
    },
    centeredContent: {
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
      textAlign: "center",
      gap: 10,
      height: "100%",
      // marginTop: 450,
    },
    content: {
      marginTop: 5,
      marginBottom: 5,
      textAlign: "justify",
      fontSize: 10,
      lineHeight: 1.5,
      wrap: false,
    },
    contentBold: {
      //   marginBottom: 5,
      textAlign: "justify",
      fontSize: 10,
      lineHeight: 1.5,
      fontWeight: "bold",
      wrap: false,
    },
    contentBoldRed: {
      //   marginBottom: 5,
      textAlign: "justify",
      fontSize: 10,
      lineHeight: 1.5,
      fontWeight: "bold",
      wrap: false,
      color: "red",
    },
    subcontent: {
      fontFamily: "Open Sans",
      fontWeight: "bold",
      textAlign: "justify",
      fontSize: 10,
      lineHeight: 1.5,
      color: `#${primaryColor}`,
    },

    subheading: {
      fontFamily: "Open Sans",
      fontSize: 12,
      letterSpacing: 1,
      marginTop: 5,
      fontWeight: "bold",
      color: `#${primaryColor}`,
      lineHeight: 1.5,
    },
    text: { marginBottom: 5, color: theme.colors.Brand1PenBlue },
    image: {
      maxWidth: 275,
      maxHeight: 215,
    },
    verticleSizedBox: {
      height: 20,
    },
    alternateRow: {
      backgroundColor: blendWithWhite(primaryColor, 0.1),
    },
    table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      bordercolor: `#${primaryColor}`,
      marginBottom: 10,
      marginTop: 10,
    },
    tableRow: {
      flexDirection: "row",
      borderBottomStyle: "solid",
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.Brand4LavenderWeb,
      wrap: false,
     
    },
    tableHeader: {
      backgroundColor: `#${primaryColor}`,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      padding: 5,
      color: theme.colors.White,
    },
    
  });

export default AnnualGuideStyles;
